import {
  Component,
  OnInit,
  ElementRef,
  ViewChild,
  AfterViewInit,
  AfterViewChecked,
  ChangeDetectionStrategy,
  ChangeDetectorRef
} from '@angular/core';
import {Subject, Observable, Subscription, timer} from "rxjs";
import {eventEmitterService} from "../../service/eventEmitter.service";
import {GroupService} from "../../service/group.service";
import {environment} from "../../../environments/environment";
import {Router, ActivatedRoute, NavigationEnd, Params} from "@angular/router";
import {PostFilterService} from '../../service/post-filter.service';
import {filter} from 'lodash';

declare var $: any

@Component({
  selector: 'app-groups',
  templateUrl: './groups.component.html',
  styleUrls: ['./groups.component.css'],
})
export class GroupsComponent implements OnInit {
  //Declared all variables
  apiUrl = environment.apiUrl;
  s3apiUrl = environment.s3BucketApi;
  onlineNewMsgGroups = [];
  allOnlineGroups = [];
  title = 'Group Application';
  message = "";
  messages = [];
  currentLength;
  onlineGroups = [];
  onlineGroupLists = [];
  buildingsFilterGroupsLists = [];
  buildingsFilterGroups = [];
  activeUser;
  userId;
  toGroupId;
  touser = {firstName: '', lastName: '', address: ''};
  socketId;
  group = {name: '', description: '', id: ''};
  messageToSend: string;
  showNewMsg = false;
  totalMsg = 0;
  showMoreOpt = false;
  responseMsg = '';
  leavingGroup = '';
  private timer;
  private sub: Subscription;
  connectedRooms = [];
  connectedRoomsWithGroups = [];

  stock;
  caption;
  files = [];
  selectedFileType;
  roomId;
  toUserId;
  imageSrc = [];
  error;
  dateUpdater = '?ver=' + Date.now();
  set_clearTimeInterval;
  isLoading = false;
  isButtonEnabled = false;
  uploadButtonToShow: boolean = true;
  dateToUpdate;
  private totalCount = {getAllMsgCount: 0, getAllGroupMsgCount: 0, getAllGroupsCount: 0};
  newMessageNoResult = false;
  noResult = false;

  // Invoke all services files when this file intial load
  constructor(
    private eventService: eventEmitterService,
    private _changeDetector: ChangeDetectorRef,
    private _groupService: GroupService,
    private route: ActivatedRoute,
    private router: Router,
    private link: PostFilterService,
  ) {
    //this._ioServiceMessages = new Array<{}>();
    //this.messageToSend = "";
  }

  //Get a reference element by using ViewChild
  @ViewChild("chatwindow", { static: false }) private chat_window: ElementRef;

  ngOnInit() {

    this.timer = timer(500, 1000);

    this.route.queryParams.subscribe((params: Params) => {
      var openGroupStatus = params['opengroup'] || '';
      var groupName = params['name'] || '';
      if (openGroupStatus && groupName) {
        this.joinPrivate({id: openGroupStatus, name: groupName});
      }
    });

    // subscribing to a observable returns a subscription object
    this.sub = this.timer.subscribe(t => {
      this._groupService.getMyGroups(); // Changed from defaultGroupInfo to getMyGroups
      if (this.onlineGroups) {

        this.sub.unsubscribe();
      }
    });

    this.eventService.eventEmit$
      .subscribe(newGroup => {
        //If user click New Message button from Message header component,
        //Here listening that evet to show new message user search section
        if (newGroup.newMsg) {
          this.showNewMessage();
          this.group = {name: '', description: '', id: ''};
        }
        //Listening building filter values from message header component event emition
        if (newGroup.filterBuilding) {
          this.resetFilterBuilding(newGroup.filterBuilding);
        }
      });

    this.eventService._msgCount$
      .subscribe(event => {
        this.totalCount.getAllMsgCount = event['getAllMsgCount'];
        this.totalCount.getAllGroupsCount = event['getAllGroupsCount'];
      });

    //Subscribed all sockets emition groups results based on current logged in user's
    this._groupService.group$
      .subscribe(message => {

        /*
        *  Get all groups based on current logged in user's
        */
        if (message["groups"] || message["allresidentsgroups"] || message["createdGroup"]) {
          const groupToProcess = message["createdGroup"] || message["allresidentsgroups"] || message["groups"];
          if (!groupToProcess) return;

          var groupId = groupToProcess.id;

          /* If groups already present in online groups list array,
          *  Only replaced last message with unreadMsg count value if group user is not in active state
          */
          if (this.onlineGroupLists.indexOf(groupId) > -1) {
            //Update Read Status to connected users
            this.onlineGroups.forEach(function callback(group, index, array) {
              if (group.id == groupId) {
                group.totalUnReadMsg = groupToProcess.totalUnReadMsg;
                group.lastMessage = groupToProcess.lastMessage;
                group.lastMessageCreatedDate = groupToProcess.lastMessageCreatedDate;
              }
            });

            if (message["buildingsFilter"] === true) {
              const existingGroupIndex = this.buildingsFilterGroups.findIndex(group => group.id === groupId);
              
              if (existingGroupIndex > -1) {
                this.buildingsFilterGroups[existingGroupIndex] = groupToProcess;
              } else {
                this.buildingsFilterGroupsLists.push(groupId);
                this.buildingsFilterGroups.push(groupToProcess);
              }
            }

          } else {

            /*
            * If a group is not present in online group list array, then the group information pushed to this array
            * And also listen for new group's come up with this current logged in user's building
            */

            this.onlineGroupLists.unshift(groupId);
            this.onlineGroups.unshift(groupToProcess);
          }


          if (this.buildingsFilterGroupsLists.length > 0) {
            const uniqueGroups = this.buildingsFilterGroups.filter((group, index, self) => 
              index === self.findIndex(g => g.id === group.id)
            );
            
            this.onlineGroups = uniqueGroups;
          }

          //Re-arranged the groups list array based on recent message time value.
          this.onlineGroups.sort(
            (a, b) => {
              var currentLMCD = isNaN(Date.parse(a.lastMessageCreatedDate)) ? 0 : Date.parse(a.lastMessageCreatedDate);
              var nextLMCD = isNaN(Date.parse(b.lastMessageCreatedDate)) ? 0 : Date.parse(b.lastMessageCreatedDate);
              if (currentLMCD > nextLMCD) {
                return -1;
              }
              if (currentLMCD < nextLMCD) {
                return 1;
              }
            });

          if (message["getAllGroupMsgCount"]) {
            this.totalCount.getAllGroupMsgCount = message["getAllGroupMsgCount"];
            this.eventService._msgCount$.next(this.totalCount);
          }
        }

        //Get a socket connection information
        if (message["session"]) {
          this.socketId = message["session"]["socketId"];
          this.userId = message["session"]["user"]["id"];
          this.activeUser = message["session"]["user"];
        }
        this.onlineGroups = filter(this.onlineGroups, group => !group.private);

        //Get all groups messages and newly created group message
        if (message["message"]) {

          let messageContent = "";

          if (message["message"] && message["allMessages"]) {

            if (message["page"] == "groups") {
              //Get Room Id
              var groupId = message['groupId'];
              var group = message['group'];

              //When other user's chat window open, initially pushed all groups messages informations
              if (this.connectedRooms.indexOf(groupId) > -1) {
              } else {
                this.currentLength = this.messages.length;
                this.connectedRooms.push(groupId);
                this.connectedRoomsWithGroups.push({groupId: groupId, group: group});
                this.messages.push({groupId: groupId, group: group, messages: message["message"]});
              }


              //Set scroll to bottom for opened chat windows,
              setTimeout(() => {
                var ele = $('#grouproom-' + groupId).find('.main_msg_inner');
                var MsgWindowHeight = ele.find('.row').height();
                // ele.scrollTop(MsgWindowHeight);
              }, 100);
            }

          } else {

            //Listening newly created a group message
            messageContent = message["message"];
            //console.log(message);
            var groupId = message['groupId'];
            var group = message['group'];

            if (message['page'] == 'groups') {
              // Pushed newly created message based on group id
              this.messages.forEach(function callback(currentValue, index, array) {
                if (currentValue.groupId == groupId) {
                  currentValue.messages.push(message["message"]);
                }
                currentValue.messages = currentValue.messages.filter((v, i, a) => a.indexOf(v) === i);
              });

              //Update read status to this new group message
              var ele = $('#grouproom-' + groupId).find('.main_msg_inner');
              // ele.find('.row').css("margin-bottom","85px");
              var MsgWindowHeight = ele.find('.row').height();
              if (ele.is(':visible') === true) {
                this.updateMsgStatus(groupId);
                setTimeout(() => {
                  $('.Firefox .groupRooms').scrollTop(99999)
                }, 300);
              }
              // ele.scrollTop(MsgWindowHeight);
              if (message["page"] == "groups") {
                if (message["message"].paths != undefined) {
                  this.isLoading = false;
                }
              }
            }

          }

        } else if (message["message"] == '') {
          this.messages = [];
        }
        this.allOnlineGroups = this.onlineGroups;
        if (!this._changeDetector['destroyed']) {
          this._changeDetector.detectChanges();
        }

      });

    this.allOnlineGroups = this.onlineGroups;

  }

  /*
  * Reset building filter array values
  */
  resetFilterBuilding(filterBuilding) {
    this.buildingsFilterGroupsLists = [];
    this.buildingsFilterGroups = [];
  }

  /*
  * Update read status to all unread group messages based on group id
  */
  updateMsgStatus(groupId) {
    this._groupService.updateMsgStatus(groupId);
  }

  /*
  * Set the boolean value for display new message on my groups page
  */
  showNewMessage() {
    this.showNewMsg = true;
    this.onlineNewMsgGroups = [];
  }

  /*
  * Send a message from my groups page
  * groupId, textarea, ref - passing params
  */
  sendMessage(groupId, textarea, e): void {

    //Check a empty value of current window textarea element
    if ($.trim($(textarea).val())) {
      //Build a object for send a new group message
      let messageObject = {
        message: {
          groupId: groupId,
          content: $.trim(textarea.value),
          page: 'groups'
        }
      }

      $(textarea).val('');
      //Call a service function to create a newly passed comment from my groups page
      this._groupService.sendGroupMessage(messageObject);
      e.preventDefault();
      setTimeout(() => {
        $('.Firefox .groupRooms').scrollTop(99999);
      }, 300);
    }
  }

  /*
  * Make a group chat room for all connected group users
  * group object - passing params
  */
  joinPrivate(group: any): void {
    this.newMessageNoResult = false;
    group.page = 'groups';
    
    //If group/Other group's already present in this array, then just show it inside window
    this.connectedRoomsWithGroups.forEach(function callback(roomsWithGroups, index, array) {
      $('#grouproom-' + roomsWithGroups.groupId).hide();
      if (roomsWithGroups.group.id == group.id) {
        $('#grouproom-' + roomsWithGroups.groupId).show();
      }
    });
    this.showNewMsg = false;
    //this.messages = [];
    this.toGroupId = group.id;
    this.group = group;
    
    //Call a service function to connect a group via socket
    this._groupService.joinPrivate(group);
    var length = (this.connectedRoomsWithGroups.length + 2) * 400;
    if ($(window).width() < length) {
      length = $(window).width();
    }
    $('.pop_up_wrap').css('width', length + 'px');

    var max_length = $(window).width() - 320;

    // if(max_length<length){
    //     $('.pop_up_chat').css('width',250+'px');
    // }
    setTimeout(() => {
      $('.Firefox .groupRooms').scrollTop(99999);
      $('#grouproom-' + group.id).find('textarea').focus();
    }, 1000);

    setTimeout(() => {
      this.eventService.triggerSocketService('groupMsg');
      var i = 0;
      var timer = setInterval(() => {
        this.eventService.triggerSocketService('groupMsg');
        i++;
        if (i === 2) {
          clearInterval(timer)
        }
      }, 1000);
    }, 500);

    $('.msgList').removeClass('current');
    setTimeout(() => {
      $('.msgContent').addClass('current');
    }, 500);
    $('#messages_header').addClass('current');
  }

  /*
  * Filtered groups list based on user search
  */
  searchUser(searchGroup) {
    var chatService = this.eventService;
    this.onlineGroups = chatService.filterGroup(this.allOnlineGroups, 'firstName', searchGroup);
    if (this.onlineGroups.length > 0) {
      this.noResult = false;
    } else {
      this.noResult = true;
    }
  }

  /*
  * Filtered groups list based on user search from new message group search section
  */
  searchNewMsgGroup(searchGroup) {

    if (!searchGroup) {
      this.onlineNewMsgGroups = [];
    } else {
      var eventService = this.eventService;
      this.onlineNewMsgGroups = eventService.filterGroup(this.allOnlineGroups, 'firstName', searchGroup);
      if (this.onlineNewMsgGroups.length <= 0) {
        this.newMessageNoResult = true;
      } else {
        this.newMessageNoResult = false;
      }
    }
  }

  /*
  * Displayed for list of options (Like Exit Group)
  */
  moreOptions(moreOpt, leaveGroup) {
    $('.showmoredrp').toggle('show')
    //    if( this.showMoreOpt === false ){
    //        this.showMoreOpt = true;
    //    }else{
    //        this.showMoreOpt = false;
    //        $('.showmoredrp').removeClass('show');
    //    }
    this.leavingGroup = leaveGroup;
  }

  /*
  * Call a service function to update leave group status.
  * Then filtered groups list based on exit group from new message group search section
  */
  exitGroup(group, confirmPopup) {

    this._groupService.leaveGroup({groupId: group.id}).subscribe((res) => {
      if (res) {
        if (res.success == true) {
          this.responseMsg = "Successfully left from this group.";

          this.eventService.eventEmit$.next({groupReset: true});
          //Reset current object values of exit group
          this.group = {name: '', description: '', id: ''};
          $('#grouproom-' + group.id).hide();
          //Remove value of exit group
          this.onlineGroups = this.onlineGroups.filter((v, i, a) => i !== a.findIndex((t) => (t.id == group.id)));
          setTimeout(() => {
            this.responseMsg = "";
            (<any>$(confirmPopup)).modal('hide');
          }, 1000);
        }
      }
    });
  }

  /*
  * Used for popup close button clicks
  */
  popupClose(confirmPopup) {
    (<any>$(confirmPopup)).modal('hide');
  }

  /*
   *
   * Listening the query param for new message user search form open
   */
  ngAfterViewInit() {
    this.route.queryParams.subscribe(
      (data: any) => {
        if (data.open) {
          $('#new_message_btn').trigger('click');
        }
      });
  }

  ngAfterViewChecked() {
    //this.chat_window.nativeElement.scrollTop = this.chat_window.nativeElement.scrollHeight;
  }


  onChange(event, roomId) {
    this.uploadButtonToShow = true;
    var src = []
    this.files = [];
    this.imageSrc = [];
    this.isButtonEnabled = false;

    var e = window.event || event;
    var target = e.target || e.srcElement;

    if (target.files.length > 0) {
      var Extension = target.files[0].name.substring(target.files[0].name.lastIndexOf('.') + 1).toLowerCase();
      var fileType = '';
      if (Extension == "gif" || Extension == "png" || Extension == "bmp"
        || Extension == "jpeg" || Extension == "jpg") {
        fileType = 'image';
      } else {
        fileType = 'document';
      }
      target.files[0].extension = Extension;
      target.files[0].fileType = fileType;
      var fileSize = target.files[0].size / 1024 / 1024;

      if (this.selectedFileType == 'image') {

        if (fileType == 'image') {

          if (fileSize <= 20) {
            this.error = null;
            this.imageSrc = src;
            for (var i = 0; i < target.files.length; i++) {
              setupReader(target.files[i]);
              this.files.push(target.files[i])
            }

            this.roomId = roomId;
            //this.toUserId = toUserId;
          } else {
            this.files = [];
            this.uploadButtonToShow = false;
            this.error = "File size must not be more than 20 MB";
          }
          $('#messageFileModal').modal('show');
        } else {
          this.files = [];
          this.uploadButtonToShow = false;
          this.error = "Please select either a .jpeg, .jpg, or .png file"
          $('#messageFileModal').modal('show');
        }

      } else if (this.selectedFileType == 'document') {

        if (fileType == "document" && Extension == 'pdf') {

          if (fileSize <= 20) {
            this.error = null;
            this.imageSrc = ['../../../../assets/images/pdf.svg'];
            for (var i = 0; i < target.files.length; i++) {
              setupReader(target.files[i]);
              this.files.push(target.files[i])
            }
            this.roomId = roomId;
          } else {
            this.files = [];
            this.uploadButtonToShow = false;
            this.error = "File size must not be more than 20 MB";
          }
          $('#messageFileModal').modal('show');
        } else {
          this.files = [];
          this.uploadButtonToShow = false;
          this.error = "Please select .pdf file format"
          $('#messageFileModal').modal('show');
        }

      }

    }

    function setupReader(file) {
      var name = file.name;
      var reader = new FileReader();
      reader.onload = function (e) {
        // get file content
        src.push(reader.result)
      }
      reader.readAsDataURL(file);
    }

  }

  uploadDocuments() {
    this.isButtonEnabled = true;

    let messageObject = {
      message: {
        groupId: this.roomId,
        content: this.files,
        caption: this.caption,
        page: 'groups'
      },
      file: this.files[0] || null
    }
    this.isLoading = true;
    this._groupService.sendChatMessageWithFile(messageObject).subscribe((res) => {
    });
    setTimeout(() => {
      this.link.chatImageRefresher('image');
    }, 2000);
    $('#messageFileModal').modal('hide');
    $('#file-upload-messages').val('');
    setTimeout(() => {
      $('.Firefox .groupRooms').scrollTop(99999)
    }, 300);
  }

  getFileExtension(path: string): string {
    return path.split('?')[0].substring(path.split('?')[0].lastIndexOf('.') + 1).toLowerCase();
  }

  triggerImageUpload(chatImageUpload, type) {
    this.selectedFileType = type;
    this.isButtonEnabled = false;
    $('#file-upload-messages').val('');
    $(chatImageUpload).trigger('click')
  }

  /*
   * Called ngOnDestroy() when a user change over to other page
   * All timer subscribtion are unsubscribed()
   */

  revert() {
    $('.msgList').addClass('current');
    $('.msgContent').removeClass('current');
    $('#messages_header').removeClass('current');
    $('.groupRooms').hide();
  }

  deleteGroup(id, deleteModal) {
    this._groupService.deleteGroup(id).subscribe((res) => {
      if (res) {
        this._groupService.getMyGroups();
        this.group = {name: '', description: '', id: ''};
        this.onlineGroups = this.onlineGroups.filter((x) => {
          return x.id !== id;
        });
        $('#grouproom-' + id).hide();
        this.eventService.triggerSocketService('groupMsg');
        this.popupClose(deleteModal);
        this.eventService.eventEmit$.next({groupReset: true});
        this.eventService.removeGroup(id);
      }
    });
  }

}
